import { computed, watch, ref } from '@vue/composition-api'

import DatePicker from '@/components/DatePicker/DatePicker'
import PhoneNumber from '@/components/PhoneNumber/PhoneNumber'
import LocationSearch from '@/components/LocationSearch/LocationSearch'

import useForm from '@/compositions/useForm'
import useRequest from '@/compositions/useRequest'

import { required, validAddressPicker } from '@/utils/validations'

export default {
  name: 'OrderCreate',
  props: {
    instances: Array,
    models: Array,
  },
  components: { DatePicker, PhoneNumber, LocationSearch },
  setup(props, context) {
    const { emit } = context
    const { $store } = context.root
    const { state } = $store

    const today = new Date().toISOString().substr(0, 10)

    const {
      validate, formData, reactiveFormData, getData, $errors, reset,
    } = useForm({
      reactive: true,
      fields: {
        shifts: { default: '', validations: { required } },
        address: { default: { address: '', position: null }, validations: { validAddressPicker } },
        dates: { default: [today, today], validations: { required } },
        phone: { default: '', validations: { required } },
        payment: { default: '', validations: { required } },
        comment: { default: '' },
      },
    })

    const { makeRequest, loading } = useRequest({
      context,
      successMessage: 'Заявка была отправлена!',
      request: data => $store.dispatch('calendar/createAdminOrder', data),
    })

    const submit = async () => {
      if (!validate()) return

      const data = getData()

      delete data.in_location_position
      delete data.in_district

      await makeRequest({
        ...data,
        address: data.address.address,
        ...data.address.position,
        instance_variants_ids: props.instances,
      })
      reset()
    }

    watch(() => reactiveFormData.value, () => emit('update', getData()), { deep: true })

    const defaultCount = 1
    const showMore = ref(false)

    const toggleShowMore = () => {
      showMore.value = !showMore.value
    }

    return {
      submit,

      loading,
      formData,
      $errors,

      showMore,
      defaultCount,
      toggleShowMore,
      payments: computed(() => state.data.payments),
      showRangeFilters: computed(() => formData.address.value.address.length > 0),
    }
  },
}
